<span class='bookmarkStar'
    [class.isSelected]='isSelected'
    (click)='switch()'></span>
